<template>
  <div class="cell-container">
    <div class="cell" v-for="i in childern" :key="i.index">
      <div class="image-container">
        <img :src="i.image" />
        <div class="name">{{i.name}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["childern"]
};
</script>
<style lang="less" scoped>
.cell-container {
  display: flex;
  justify-content: space-around;
  .cell {
    margin: 10px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-around;
    width: 328px;
    height: 236px;
    background-color: #f7f7f7;
    border-radius: 10px;
    border: solid 3px #f8f8f8;
    .image-container {
      // border: solid 1px white;
      border-radius: 10px;
      background-color: #999999;
      position: relative;
      img {
        width: 100%;
        height: 100%;
        border-radius: 10px;
      }
      .name {
        position: absolute;
        border-radius: 0px 0px 10px 10px;
        height: 25px;
        background-color: #33333399;
        top: 205px;
        left: 0;
        color: #ffffff;
        font-size: 16px;
        text-align: center;
        width: 100%;
      }
    }

    .icon {
      width: 184px;
      height: 184px;
    }
    .text {
      width: 296px;
    }
  }
}
</style>
